import script from "./kalio-calendly-schedule.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-calendly-schedule.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__